var map = {
	"./client/config/navigation.js": 43380,
	"./company/config/navigation.js": 7708,
	"./diet_management_kitchen/config/navigation.js": 23608,
	"./diet_management_nurse/config/navigation.js": 71381,
	"./diet_management_nutritionist/config/navigation.js": 72902,
	"./general_service/config/navigation.js": 39747,
	"./human_resources/config/navigation.js": 18572,
	"./patient/config/navigation.js": 94186,
	"./pharmacy/config/navigation.js": 23510,
	"./user/config/navigation.js": 33488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82807;